import { motion } from "framer-motion";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { SectionHeader } from "../components/Services";
import LeadForm from "../components/LeadForm";

const PILLS = [
    { icon: Mail, label: "Email", value: "hello@proksyresearch.com" },
    { icon: Phone, label: "Phone", value: "+1 (302) 551-0884" },
    { icon: MapPin, label: "Location", value: "2044 Limestone Rd, Wilmington, DE 19808" },
    { icon: Clock, label: "Response", value: "Within 1 business day" },
];

export default function Contact() {
    return (
        <main className="pt-32" data-testid="contact-page">
            <section className="relative pb-8">
                <div className="absolute inset-0 bg-grid bg-grid-fade opacity-30 pointer-events-none" />
                <div className="pr-container relative">
                    <SectionHeader
                        overline="Contact"
                        title="Let's talk about your study"
                        subtitle="Share a few details and we'll come back with a tailored sample plan, methodology and price within one business day."
                    />

                    <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-3">
                        {PILLS.map((p, i) => {
                            const Icon = p.icon;
                            return (
                                <motion.div
                                    key={p.label}
                                    initial={{ opacity: 0, y: 16 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: i * 0.07 }}
                                    className="pr-glass rounded-2xl p-4"
                                    data-testid={`contact-pill-${i}`}
                                >
                                    <div className="flex items-center gap-3">
                                        <div className="w-9 h-9 rounded-lg bg-blue-500/10 border border-blue-400/30 flex items-center justify-center">
                                            <Icon className="w-4 h-4 text-blue-300" />
                                        </div>
                                        <div>
                                            <p className="font-mono-pr text-[10px] uppercase tracking-widest text-blue-300">
                                                {p.label}
                                            </p>
                                            <p className="text-sm text-white font-outfit">
                                                {p.value}
                                            </p>
                                        </div>
                                    </div>
                                </motion.div>
                            );
                        })}
                    </div>
                </div>
            </section>

            <LeadForm />
        </main>
    );
}
